module.exports = __webpack_public_path__ + "assets/img/liuJiYang.3ac01e55.png";